import { FC } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import './App.scss';
import { v4 as uuidv4 } from 'uuid';
import InputSerial from './components/Pages/InputSerial';
import Lesson from './components/Pages/Lesson';
import Training from './components/Pages/Training';
import Header from './components/Templates/Header';
import { PAGE_PATH_NAME } from './utils/const';
import usePageTitle from './hooks/usePageTitle';

const App: FC = () => {
  const { pathname } = useLocation();
  const { pageTitle } = usePageTitle();
  document.title = pageTitle;

  // 以下の理由で、ページ移動でHeaderを再描画する
  // iPhone横向き & アドレスバー非表示状態で、トレーニング画面に遷移すると
  // ヘッダのアイコンなどが、ヘッダをはみ出して、アドレスバーの下に表示されてしまう。
  // アイコンなどがずれる影響で、Hopなどでセンテンスが隠れてしまう。
  // （要素自体は、ヘッダ内に存在しているがなぜか表示だけはみ出したままになる。）
  // そのため、ページ移動時に、Headerコンポーネントを再生成する。
  return (
    <>
      <div className="app">
        <div
          className={`wrapper${
            pathname === PAGE_PATH_NAME.LESSON ? ' mod-lesson' : ''
          }`}
        >
          <Switch>
            <Route exact path={PAGE_PATH_NAME.SERIAL_INPUT}>
              <Header />
              <InputSerial />
            </Route>
            <Route exact path={PAGE_PATH_NAME.LESSON}>
              <Header />
              <Lesson />
            </Route>
            <Route exact path={PAGE_PATH_NAME.TRAINING} key={uuidv4()}>
              <Header />
              <Training />
            </Route>
          </Switch>
        </div>
      </div>
    </>
  );
};

export default App;
